export enum ConfirmationType {
  Normal = 0,
  Redirect = 1,
  RedirectWithProps = 2,
}

export function shouldEventTypeRedirect(confirmationType: ConfirmationType) {
  return [
    ConfirmationType.Redirect,
    ConfirmationType.RedirectWithProps,
  ].includes(confirmationType);
}
